/**
 * PGF Legal Disclaimer Component
 * 
 * IP COMPLIANCE v2, Section 5 - REQUIRED on every page of the product.
 * See /app/IP_COMPLIANCE.md
 *
 * This disclaimer must appear on all pages to maintain the First Amendment
 * informational use defense for player photos inside the draft interface.
 */

export default function LegalDisclaimer({ className = "" }) {
  return (
    <p
      className={`text-[#555] font-body text-xs text-center leading-relaxed ${className}`}
      data-testid="legal-disclaimer"
    >
      Pregame Fantasy is a product of Pregame Fantasy LLC. Pregame Fantasy LLC is not affiliated with, endorsed by, or licensed by the National Football League, any NFL team, or the NFLPA.
    </p>
  );
}
